import React, { useEffect } from "react";
import { Chip, ListItem, TextField } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { useSelector } from "react-redux";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Slider from "@material-ui/core/Slider";
import { withStyles } from "@material-ui/styles";
import Button from "@material-ui/core/Button";
import { isEqual } from "../helper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";

import dairyFreeIcon from "../../../ActionButton/assests/no-milk.png";
import glutenFreeIcon from "../../../ActionButton/assests/gluten-free.png";
import sugarFreeIcon from "../../../ActionButton/assests/sugar-free.png";
import nutFreeIcon from "../../../ActionButton/assests/peanut-free.png";
import organicIcon from "../../../ActionButton/assests/bio_480.png";
import vegetarianIcon from "../../../ActionButton/assests/leaf.png";
import veganIcon from "../../../ActionButton/assests/vegan.png";
import glutenIcon from "../../../ActionButton/assests/gluten.png";
import nutsSesameIcon from "../../../ActionButton/assests/nuts_sesame.png";
import dairyIcon from "../../../ActionButton/assests/dairy.png";
import eggIcon from "../../../ActionButton/assests/egg.png";
import seafoodShellfishIcon from "../../../ActionButton/assests/seafood_shellfish.png";
import chilliIcon from "../../../ActionButton/assests/chilli.png"; 
const CustomSlider = withStyles({
  valueLabel: {
    top: -22,
    left: -11,
    fontSize: 15,
    "& *": {
      background: "transparent",
      color: "#000",
    },
  },
  thumb: {
    height: 14,
    width: 14,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  markLabel: {
    fontWeight: "bold",
    fontSize: 15,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
})(Slider);

const NutritionFactFilter = ({ nutritionalFact, setNutritionalFact }) => {
  //REDUX
  const themeColor = useSelector((state) => state.store.store.settings?.dark);
  const language = useSelector((state) => state.store.language);
  const nutritionalFactMaxMin = useSelector(
    (state) => state.productFilter?.allProductNutritionFact
  );

  //COMPONENT STATE
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(nutritionalFact);

  //COMPONENT FUNCTIONS
  const handleClick = () => {
    setOpen(!open);
  };

  const handleChangeRange = (event, newValue, item) => {
    setValue({
      ...value,
      [item]: newValue,
    });
  };

  const handleChange = (event) => {
    setValue({
      ...value,
      dietaryRestrictions: event.target.value,
    });
  };

  const checkIfFilterIsApplied = () => {
    return !isEqual(nutritionalFact, {
      ...nutritionalFactMaxMin,
      dietaryRestrictions: [],
    });
  };

  const handleDisableApplyButton = () => {
    return (
      isEqual(value, nutritionalFact) ||
      isEqual(value, {
        ...nutritionalFactMaxMin,
        dietaryRestrictions: [],
      })
    );
  };
  const valuetext = (value) => {
    return (
      <span
        style={{
          fontWeight: "bold",
          fontSize: 15,
        }}
      >
        {`${value}`}
      </span>
    );
  };

  const arabicTranslate = {
    calories: "السعرات الحرارية",
    fats: "الدهون",
    carbs: "الكربوهيدرات",
    protein: "البروتين",
    dietaryRestrictions: "القيود الغذائية",
    "Dairy free": "خالي من منتجات الألبان",
    "Gluten free": "خالي من الغلوتين",
    "Sugar free": "خالي من السكر",
    "Nut free": "خالي من المكسرات",
    Vegan: "فيغن",
    Vegetarian: "نباتي",
    Organic: "عضوي",
    Gluten: "الغلوتين",
    "Nuts/Sesame": "مكسرات/سمسم",
    Dairy: "ألبان",
    Egg: "بيض",
    "Seafood/Shellfish": "مأكولات بحرية/قشريات",
    Chilli: "حار",
  };

  const iconTable = {
    "Dairy free": dairyFreeIcon,
    "Gluten free": glutenFreeIcon,
    "Sugar free": sugarFreeIcon,
    "Nut free": nutFreeIcon,
    Vegan: veganIcon,
    Vegetarian: vegetarianIcon,
    Organic: organicIcon,
  
  Gluten: glutenIcon,
  "Nuts/Sesame": nutsSesameIcon,
  Dairy: dairyIcon,
  Egg: eggIcon,
  "Seafood/Shellfish": seafoodShellfishIcon,
  Chilli: chilliIcon,

  };

  return (
    <>
      <ListItem
        button
        onClick={handleClick}
        style={{
          paddingLeft: language === "arabic" ? "" : 0,
          paddingRight: language === "arabic" ? 0 : "",
          marginTop: 15,
          direction: language === "arabic" ? "rtl" : "ltr",
          marginBottom: 10,
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: "26px",
              width: "6px",
              backgroundColor: checkIfFilterIsApplied()
                ? themeColor
                : "transparent",
            }}
          ></div>
          <span
            style={{
              flex: 1,
              marginLeft: language === "arabic" ? 0 : 16,
              marginRight: language === "arabic" ? 16 : 0,
              fontWeight: "bold",
              fontSize: "15px",
              textAlign: language === "arabic" ? "right" : "left",
            }}
          >
            {language === "arabic" ? "القيم الغذائية" : "Nutrition Facts"}
          </span>
          {checkIfFilterIsApplied() && (
            <FiberManualRecordIcon
              style={{
                fontSize: 14,
                color: themeColor,
                marginRight: language === "arabic" ? 0 : 10,
                marginLeft: language === "arabic" ? 10 : 0,
              }}
            />
          )}
        </div>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
        style={{
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        {Object.keys(nutritionalFact)?.map((item, index) => {
          if (item !== "dietaryRestrictions") {
            return (
              <ListItem
                style={{
                  flexDirection: language === "arabic" ? "row-reverse" : "row",
                }}
              >
                <p
                  style={{
                    marginLeft: language === "arabic" ? 0 : 16,
                    marginRight: language === "arabic" ? 16 : 0,
                    marginBottom: 0,
                    fontWeight: "bold",
                    fontSize: "12px",
                    textAlign: language === "arabic" ? "right" : "left",
                    width: "20%",
                  }}
                >
                  {language === "arabic"
                    ? arabicTranslate[item]
                    : item.charAt(0).toUpperCase() + item.slice(1)}
                </p>
                <div
                  style={{
                    width: "100%",
                    padding: "0 16px 0 16px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    flex: 1,
                  }}
                >
                  <CustomSlider
                    value={value[item]}
                    marks={[
                      {
                        value: nutritionalFactMaxMin[item][0],
                        label: `${nutritionalFactMaxMin[item][0]}`,
                      },
                      {
                        value: nutritionalFactMaxMin[item][1],
                        label: `${nutritionalFactMaxMin[item][1]}`,
                      },
                    ]}
                    min={nutritionalFactMaxMin[item][0]}
                    max={nutritionalFactMaxMin[item][1]}
                    defaultValue={[
                      nutritionalFactMaxMin[item][0],
                      nutritionalFactMaxMin[item][1],
                    ]}
                    onChange={(event, newValue) => {
                      handleChangeRange(event, newValue, item);
                    }}
                    valueLabelDisplay={
                      isEqual(value[item], [
                        nutritionalFactMaxMin[item][0],
                        nutritionalFactMaxMin[item][1],
                      ])
                        ? "off"
                        : "on"
                    }
                    aria-labelledby="range-slider"
                    getAriaValueText={valuetext}
                  />
                </div>
              </ListItem>
            );
          }
        })}
        <ListItem>
          <div
            style={{
              width: "100%",
              padding: "0 8px",
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: language === "arabic" ? "row-reverse" : "row",
              alignItems: "center",
            }}
          >
            <p
              style={{
                marginLeft: language === "arabic" ? 0 : 8,
                marginRight: language === "arabic" ? 8 : 0,
                marginBottom: 0,
                fontWeight: "bold",
                fontSize: "12px",
                textAlign: language === "arabic" ? "right" : "left",
                width: "20%",
              }}
            >
              {language === "arabic"
                ? "القيم الغذائية"
                : "Dietary Restrictions"}
            </p>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flex: 1,
              }}
            >
              <FormControl
                dir={language === "english" ? "ltr" : "rtl"}
                InputLabelProps={{
                  shrink: true,
                  style: {
                    direction: language === "arabic" ? "rtl" : "ltr",
                    textAlign: language === "arabic" ? "right" : "left",
                  },
                }}
                style={{
                  width: "100%",
                  marginRight: language === "arabic" ? 10 : 0,
                  marginLeft: language === "arabic" ? 0 : 10,
                  direction: language === "arabic" ? "rtl" : "ltr",
                }}
              >
                <Select
                  style={{
                    textAlign: language === "arabic" ? "right" : "left",
                    direction: language === "arabic" ? "rtl" : "ltr",
                  }}
                  inputProps={{
                    dir: language === "english" ? "ltr" : "rtl",
                  }}
                  labelId="demo-mutiple-chip-label"
                  id="demo-mutiple-chip"
                  renderValue={(selected) => (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {selected.map((value) => (
                        <Chip
                          key={value}
                          label={
                            language === "arabic"
                              ? arabicTranslate[value]
                              : value
                          }
                          style={{
                            margin: 2,
                            backgroundColor: themeColor,
                            color: "white",
                          }}
                        />
                      ))}
                    </div>
                  )}
                  multiple
                  value={value["dietaryRestrictions"]}
                  onChange={handleChange}
                  input={
                    <Input
                      InputProps={{
                        inputProps: {
                          style: { textAlign: "right", direction: "rtl" },
                        },
                      }}
                    />
                  }
                >
                  {[
                    "Dairy free",
                    "Gluten free",
                    "Sugar free",
                    "Nut free",
                    "Vegan",
                    "Vegetarian",
                    "Organic",
                    "Gluten",
                    "Nuts/Sesame",
                    "Dairy",
                    "Egg",
                    "Seafood/Shellfish",
                    "Chilli",
                  ].map((name) => (
                    <MenuItem
                      key={name}
                      value={name}
                      style={{
                        textAlign: language === "arabic" ? "right" : "left",
                        direction: language === "arabic" ? "rtl" : "ltr",
                      }}
                    >
                      <img
                        alt={name}
                        src={iconTable[name]}
                        style={{
                          marginRight: 10,
                          marginLeft: 10,
                          height: 17,
                          width: 17,
                        }}
                      />
                      <span>
                        {language === "arabic" ? arabicTranslate[name] : name}{" "}
                      </span>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </ListItem>

        <ListItem>
          <div
            style={{
              width: "100%",
              padding: "0 8px",
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: language === "arabic" ? "row-reverse" : "row",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setNutritionalFact(value);
                setOpen(false);
              }}
              size={"small"}
              style={{
                marginLeft: language === "arabic" ? 0 : 25,
                marginRight: language === "arabic" ? 25 : 0,
                marginTop: 5,
                textTransform: "none",
                boxShadow: "none",
              }}
              disabled={handleDisableApplyButton()}
            >
              {language === "arabic" ? "تطبيق" : "Apply"}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setNutritionalFact({
                  ...nutritionalFactMaxMin,
                  dietaryRestrictions: [],
                });
                setValue({
                  ...nutritionalFactMaxMin,
                  dietaryRestrictions: [],
                });
                setOpen(false);
              }}
              size={"small"}
              style={{
                marginLeft: language === "arabic" ? 0 : 10,
                marginRight: language === "arabic" ? 10 : 0,
                marginTop: 5,
                color: "rgb(51, 51, 51)",
                backgroundColor: "rgb(255, 255, 255)",
                border: " 1px solid rgb(222, 222, 222)",
                textTransform: "none",
                boxShadow: "none",
              }}
            >
              {language === "arabic" ? "مسح" : "Clear"}
            </Button>
          </div>
        </ListItem>
      </Collapse>
    </>
  );
};

export default NutritionFactFilter;
